var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQueuesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 430 656",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#019985;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M254.72,281.2c-11.93,7.11-25.58,10.88-39.55,10.88-42.6,0-77.26-34.66-77.26-77.26,0-13.97,3.75-27.62,10.88-39.55L50.33,76.81C19.04,114.16.18,162.27.18,214.8c0,118.73,96.26,214.99,214.99,214.99,25.97,0,50.86-4.6,73.9-13.04v98.44l141.09,141.09v-199.63l-175.45-175.45h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M175.12,148.74c12.05-7.32,25.89-11.19,40.07-11.19,42.6,0,77.26,34.66,77.26,77.26,0,14.18-3.87,28.01-11.19,40.07l148.93,148.93v-183.95h-.07c.04-1.67.07-3.35.07-5.04C430.18,96.08,333.92-.18,215.18-.18,162.43-.18,114.14,18.84,76.73,50.36l98.39,98.39h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueuesIcon);
export default __webpack_public_path__ + "static/media/queues_icon.edc90c82acbebee6f9bf34771064ddc2.svg";
export { ForwardRef as ReactComponent };